/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_TrackingInputs */

const he_home_trust_tracking = /** @type {(inputs: Home_Trust_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעקב היסטוריית מחירים 24/7`)
};

const en_home_trust_tracking = /** @type {(inputs: Home_Trust_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 tracking`)
};

/**
* | output |
* | --- |
* | "24/7 tracking" |
*
* @param {Home_Trust_TrackingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_trust_tracking = /** @type {((inputs?: Home_Trust_TrackingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_TrackingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_trust_tracking(inputs)
	return en_home_trust_tracking(inputs)
});